import React, { ReactNode } from 'react';
import { ActionsFeature, TblCol } from './table.types';
import TableFltInputText from './TableFltInputText';
import TableFltInputDropList from './TableFltInputDropList';
import TableFltInputMultiSelect from './TableFltInputMultiSelect';

export type TblFiltersParams = {
    actions?: ActionsFeature[];
    cols?: TblCol[];
    filters?: object;
    onFilter?: (key: string, val: any) => void;
    children?: ReactNode;
};

const TableFilters = ({ actions, cols, filters, children, onFilter }: TblFiltersParams): JSX.Element => {
    function handleFilterChange(key: string, val: any): void {
        if (!!onFilter) {
            onFilter(key, val);
        }
    }

    if (!cols) {
        return <tr className="column-filters">{children}</tr>;
    }

    return (
        <tr className="column-filters">
            {actions?.map((action, idx) => {
                const ColumnFilterRenderer = action.columnFilterRenderer;
                return (
                    <td
                        key={idx}
                        className="actions-column"
                    >
                        {<ColumnFilterRenderer />}
                    </td>
                );
            })}
            {cols.map((col, colIndex) => {
                if (!onFilter || !col.hasFilter) {
                    return <td key={col.key} />;
                } else {
                    const fltVal = !!filters && typeof filters[col.key] != 'undefined' ? filters[col.key] : '';
                    const fltKey = col.key + 'flt';
                    const isRightmostColumns = colIndex >= cols.length - 2; // Last 2 columns align right

                    switch (col.type) {
                        case 'TEXT':
                        case 'MULTITEXT':
                        case 'DATE':
                        case 'COMMA_SEPARATED_NUMBER':
                        case 'CURRENCY':
                        case 'BOOLEAN':
                        case 'NUMBER':
                            return (
                                <td key={col.key}>
                                    <TableFltInputText
                                        id={fltKey}
                                        val={fltVal}
                                        onFilter={val => handleFilterChange(col.key, val)}
                                    />
                                </td>
                            );
                        case 'DROPTEXT':
                            return (
                                <td key={col.key}>
                                    <TableFltInputDropList
                                        id={fltKey}
                                        val={fltVal}
                                        options={col.fltOptions}
                                        onFilter={val => handleFilterChange(col.key, val)}
                                    />
                                </td>
                            );
                        case 'MULTISELECT':
                            return (
                                <td key={col.key}>
                                    <TableFltInputMultiSelect
                                        id={fltKey}
                                        val={Array.isArray(fltVal) ? fltVal : []}
                                        options={col.fltOptions}
                                        onFilter={val => handleFilterChange(col.key, val)}
                                        align={isRightmostColumns ? 'right' : 'left'}
                                    />
                                </td>
                            );
                        default:
                            return <td key={col.key} />;
                    }
                }
            })}
        </tr>
    );
};

export default TableFilters;
